import { atom } from 'recoil';

import { Workspace } from '@pages/select-workspace/types';
import { Atoms } from '@store/constants';

export const workspaceAtom = atom({
  key: Atoms.workspace,
  default: {} as Workspace,
});
